import { Box, Flex, Form, SubmitButton, TextInputField } from '@/components';
import { UserSearchFormSchema } from '@/features/tenant-manager/user/_models/user';
import { useForm } from '@/hooks';
import { zodResolver } from '@hookform/resolvers/zod';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router';
import type { z } from 'zod';

type FormValues = z.infer<typeof UserSearchFormSchema>;

export const UserSearchForm: FC = () => {
  const { t } = useTranslation();
  const [searchParams, setSearchParams] = useSearchParams();
  const {
    control,
    handleSubmit,
    formState: { errors, isDirty },
  } = useForm<FormValues>({
    defaultValues: {
      name: searchParams.get('name') ?? undefined,
      email: searchParams.get('email') ?? undefined,
    },
    resolver: zodResolver(UserSearchFormSchema),
  });

  return (
    <Form
      layout="vertical"
      leavePageAlertCondition={null}
      onFinish={handleSubmit(({ name, email }) => {
        name ? searchParams.set('name', name) : searchParams.delete('name');
        email ? searchParams.set('email', email) : searchParams.delete('email');
        if (isDirty) {
          searchParams.delete('page');
        }
        setSearchParams(searchParams, { replace: true });
      })}
    >
      <Box marginBottom={24}>
        <Flex gap={16} align="flex-end">
          <TextInputField
            name="name"
            autocompleteKey="user.name"
            label={t('name')}
            control={control}
            errors={errors}
            width={250}
            marginBottom={0}
          />
          <TextInputField
            name="email"
            autocompleteKey="user.email"
            label={t('email')}
            control={control}
            errors={errors}
            width={250}
            marginBottom={0}
          />
          <SubmitButton text={t('search')} />
        </Flex>
      </Box>
    </Form>
  );
};
